<template>
  <div style="background-color: #ffffff" class="container">
    <h3 class="text-dark mt-5 mb-4 font-weight-bold">
      Frequently Asked Questions
    </h3>
    <!-- error msg -->
    <b-alert
      v-for="msg in errorMsg"
      :key="msg.timestamp"
      show
      variant="danger-cus"
      dismissible
    >
      <p v-if="msg.msg !== null" class="mt-0 mb-0">{{ msg.msg }}</p>
    </b-alert>
    <!-- success api -->
    <!-- query -->
    <b-row class="mt-2 mb-3" align-h="between">
      <b-col class="mb-2" sm="12" md="6">
        <b-input-group>
          <b-form-input
            placeholder="Search..."
            v-model="faqQuery"
            v-on:keyup.enter="getFAQlist"
          ></b-form-input>
          <template #append>
            <b-button variant="info" class="text-white font-weight-bold">
              <i class="fa fa-search fa-lg" aria-hidden="true" />
            </b-button>
          </template>
        </b-input-group>
      </b-col>
    </b-row>
    <h6 class="mt-2 mb-1 text-capitalize">Tag :</h6>
    <b-button-group size="sm" class="mb-4">
      <b-button
        :pressed="urlQuery === ''"
        @click="selectBygroup('all')"
        variant="outline-primary"
        class="text-capitalize font-weight-bold"
      >All</b-button>
      <b-button
        v-for="(btn , index) in optionGroup" :key="'btn'+index" 
        @click="selectBygroup(btn.value)"
        :pressed="selected === btn.value"
        variant="outline-primary"
        class="text-capitalize font-weight-bold"
      >{{ btn.text }}</b-button>
    </b-button-group>
    <!-- <b-form-group
      class="mb-5"
      label="Tag :"
      v-slot="{ ariaDescribedby }"
    > -->
      <!-- 
        <b-form-radio-group
          id="radio-group-1"
          v-model="selected"
          :options="optionGroup"
          :aria-describedby="ariaDescribedby"
          name="radio-options"
          @change="selectBygroup"
        ></b-form-radio-group> 
      -->
      <!-- 
        <b-form-checkbox-group
          id="checkbox-group-1"
          v-model="selected"
          :options="optionGroup"
          :aria-describedby="ariaDescribedby"
          name="flavour-1"
          @change="selectBygroup"
        ></b-form-checkbox-group> 
      -->
    <!-- </b-form-group> -->
    <!-- loading -->
    <div v-if="listBusy" class="mt-3 text-center">
      <b-spinner small class="mr-2"></b-spinner>
      <strong>Loading Frequently Asked Questions ...</strong>
    </div>
    <div v-else>
      <div v-if="dataFaq.length != 0">
        <!-- pagination -->
        <!--  
          <div class="mb-5">
            <b-pagination
              id="FAQ-list"
              v-model="btnPage"
              :total-rows="countObjData"
              :per-page="pageSize"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="handlePageChange"
            ></b-pagination>
          </div>
        -->
        <!-- content -->
        <div
          id="FAQ-list"
          class="accordion mt-3"
          role="tabpanel"
          v-for="(item, index) in dataFaq"
          :key="'faq' + index"
        >
          <b-link
            variant="link"
            class="h5 font-weight-bold f-color-link"
            v-b-toggle="`faq-${index}`"
            @click="visible = index"
          >
            <b-media>
              <template #aside>
                <i
                  class="mt-1 fa"
                  :class="{
                    'fa-minus-circle': visible === index,
                    'fa-plus-circle': visible !== index,
                  }"
                  aria-hidden="true"
                />
              </template>
              <p class="mt-0 mb-0">
                {{ item.question }}
              </p>
            </b-media>
          </b-link>
          <b-collapse :id="`faq-${index}`" accordion="my-faq" role="tabpanel">
            <b-card-body class="ml-3">
              <b-card-text class="text-justify">
                <span class="mt-0 mb-0" v-html="item.answer"></span>
              </b-card-text>
            </b-card-body>
          </b-collapse>
          <hr />
        </div>
        <!-- pagination -->
        <div class="mt-5 mb-5">
          <b-pagination
            v-if="countObjData > 30"
            id="FAQ-list"
            v-model="btnPage"
            :total-rows="countObjData"
            :per-page="pageSize"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
            @change="handlePageChange"
          ></b-pagination>
        </div>
      </div>
      <div v-else class="text-center mt-2 mb-2">
        <h5 class="mt-0 mb-0">
          Didn't find the information you searched for ?
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: null,
      errorMsg: [],
      faqQuery: "",
      selected: "",
      // selected: [],
      urlQuery: '',
      optionGroup: [],
      dataFaq: [],
      // pagegination
      btnPage: 1,
      offset: 0,
      pageSize: 30,
      countObjData: 0,
      bthNext: null,
      bthPrev: null,
      // loading
      listBusy: false,
    };
  },
  mounted() {
    this.setOptionGroup();
    this.getFAQlist();
  },
  methods: {
    handlePageChange(value) {
      this.btnPage = value;
      this.offset = parseInt(value - 1) * parseInt(this.pageSize);
      this.getFAQlist();
    },
    async setOptionGroup() {
      this.optionGroup = [];
      try {
        const res = await this.$http.get(`/faq/group/?topic=${this.$route.query.topic}`);
        if (res.status === 200) {
          this.optionGroup = res.data.map((item) => {
            return {
              text: item.group_name,
              value: item.id,
              view_order: item.view_order
            };
          });
          this.optionGroup.sort((a, b) => {
            return b.view_order - a.view_order;
          });
        } else {
          throw { res };
        }
      } catch (error) {
        this.optionGroup = [];
      }
    },
    selectBygroup(val){
      // this.urlQuery = ''
      // for (let index = 0; index < val.length; index++) {
      //   if(val[index] !== null){
      //     this.urlQuery += ''
      //       +`&group=${val[index]}`
      //     '';
      //   }
      // }
      this.urlQuery = val === 'all' ? '' : `&group=${val}`
      this.selected = val
      // console.log(this.urlQuery)
      this.getFAQlist()
    },
    async getFAQlist() {
      this.listBusy = true;
      this.errorMsg = [];
      this.dataFaq = [];
      try {
        let setUrl = this.urlQuery === '' ? `/faq/?topic=${this.$route.query.topic}&search=${this.faqQuery}&limit=${this.pageSize}&offset=${this.offset}` : `/faq/?topic=${this.$route.query.topic}&search=${this.faqQuery}${this.urlQuery}&limit=${this.pageSize}&offset=${this.offset}`
        const res = await this.$http.get(setUrl);
        if (res.status === 200) {
          this.dataFaq = res.data.results.map((item) => ({ ...item }));
          this.dataFaq.sort((a, b) => {
            return b.view_order - a.view_order;
          });
          // pagegination
          this.countObjData = res.data.count;
          this.bthNext = res.data.next;
          this.bthPrev = res.data.previous;
          this.offset = 0;
          // load
          this.listBusy = false;
        } else {
          throw { res };
        }
      } catch (error) {
        this.dataFaq = [];
        this.errorMsg.push({
          timestamp: new Date().getTime(),
          msgstatus: error.response.status,
          msgstatusText: error.response.statusText,
          msg: Object.values(error.response.data)[0],
        });
        if (this.errorMsgsSignup.length > 1) this.errorMsgsSignup.shift();
        this.listBusy = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-app {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 5px;
}
.f-color-link {
  color: #0067b8;
}
.f-300 {
  font-size: 12px;
  font-weight: 300;
}
.alert-danger-cus {
  background-color: #f7c3cf;
  color: #080808;
}
.form-control {
  background-color: #ffffff;
  border: 1px solid #ced4da;
  color: #000;
  font-size: 14px;
  transition: background-color 0.3s ease 0s;
  padding: 7px 18px;
  height: 40px;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.btn-outline-primary {
    color: #007bff;
    border-color: #007bff;
}
.btn-outline-primary:hover {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}
.btn-outline-primary:focus {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}
</style>